export * from './ngx-pagination-bootstrap-component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/index.ts